export const HeightClasses = {
  HEIGHT_SCREEN: ['wf-min-h-screen'],
  HEIGHT_XL: ['wf-h-56'],
  HEIGHT_FULL: ['wf-min-h-full'],
}